module.exports = __webpack_public_path__ + "img/icon_security_2FWA.c0ecfde.png";